var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.loggedIn)?_c('DashboardDisplayer'):_c('Welcome'),_c('Alert',{ref:"iAlert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }